<template lang="pug">
  .slide-show
    flickity(ref="primarySlideshow" :options="slideshowPrimaryOptions" :class="slideshowPrimaryClass" :style="slideshowPrimaryStyle")
      slot(name="primary")
    flickity(v-if="isMobile" ref="secondarySlideshow" :options="slideshowSecondaryOptions" class="slideshow slideshow--secondary" :style="slideshowSecondaryStyle")
      slot(name="secondary")

</template>

<script>
  import Flickity from 'vue-flickity';
  import 'flickity-as-nav-for';

  export default {
    name: 'Slideshow',
    components: {
      Flickity,
    },
    props: {
      slideshowPrimaryClass: String,
      slideshowPrimaryOptions: Object,
      slideshowPrimaryRef: String,
      slideshowPrimaryStyle: String,
      slideshowSecondary: {
        type: Boolean,
        defaut: false,
      },
      slideshowSecondaryClass: String,
      slideshowSecondaryOptions: Object,
      slideshowSecondaryRef: String,
      slideshowSecondaryStyle: String,
    },
    computed: {
      isMobile () {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.$refs.secondarySlideshow) {
          let sliderHeight = this.$refs.secondarySlideshow.$el.clientHeight;
          this.$refs.secondarySlideshow.$el.querySelectorAll('.slideshow__text-container').forEach(($slide) => {
            if($slide.clientHeight > sliderHeight)
              this.$refs.secondarySlideshow.$el.style.height = `${$slide.clientHeight}px`;
          });
        }
      });
    },
  };
</script>
